import { INPUT_TYPE } from "../constants";

export const CREATE_CONFIG_CONFIGS = [
  {
    fieldName: "label",
    label: "Field Name",
    inputType: INPUT_TYPE.TEXT,
    required: true,
  },
  {
    fieldName: "inputType",
    label: "Field Type",
    inputType: INPUT_TYPE.SELECT,
    required: true,
    enumValues: Object.values(INPUT_TYPE)
      .filter((item) => item !== "FILE")
      .map((type) => ({
        value: type,
        name: type,
      })),
  },
  {
    fieldName: "enumValues",
    label: "Only use this if the input type is select, enter the item seperate by comma",
    inputType: INPUT_TYPE.TEXT_AREA,
  },
  {
    fieldName: "showInDashboard",
    label: "Show in Dashboard",
    inputType: INPUT_TYPE.BOOLEAN,
  },
  {
    fieldName: "description",
    label: "Description",
    inputType: INPUT_TYPE.TEXT_AREA,
  },
];
